<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12 7a1 1 0 00-1 1v16a1 1 0 002 0V8a1 1 0 00-1-1zM20 7a1 1 0 00-1 1v16a1 1 0 002 0V8a1 1 0 00-1-1z"/></svg>